import i from"styled-components";import{theme as e}from"../../../theme.js";const n=i.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-gap: ${e.spacing*2}px;
  align-items: center;
`,a=i.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${e.spacing*4}px;
  a {
    color: inherit;
    text-decoration: none;
  }
`,o=i.div`
  padding: ${e.spacing*4}px;
  border-radius: ${e.radius}px;
  background-color: ${e.colors.gray[50]};
  display: flex;
  flex-direction: column;
  gap: ${e.spacing*4}px;
`,r=i.span`
  font-size: 12px;
  color: ${e.colors.gray[400]};
`,p=i.div`
  display: flex;
  flex-direction: column;
  gap: ${e.spacing*4}px;
  padding-left: ${e.spacing*12}px;
  @media screen and (max-width: ${e.breakpoints.md}) {
    padding-left: ${e.spacing*4}px;
  }
`,t=i.p`
  margin: 0;
  font-size: 16px;
  color: ${e.colors.gray[600]};
  line-height: 24px;
`;export{t as Comment,o as Container,p as ContentContainer,r as Date,a as HeaderContainer,n as UserContainer};
